import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsFooter = ({ onCallCrisis, onViewResources }) => {
  return (
    <div className="card-elevated p-6 bg-primary/5">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Icon name="Lightbulb" size={24} className="text-primary" />
          <div>
            <h3 className="text-base font-semibold text-foreground">Need immediate support?</h3>
            <p className="text-sm text-muted-foreground">Our crisis resources are available 24/7</p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="outline"
            iconName="Phone"
            iconPosition="left"
            onClick={onCallCrisis}
          >
            Call Crisis Line
          </Button>
          <Button
            variant="ghost"
            iconName="AlertCircle"
            iconPosition="left"
            onClick={onViewResources}
          >
            View Resources
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsFooter;